<template>
    <div>

        <div class="cc-banner"
        data-content-text="Wij gebruiken cookies en andere technologieën om uw gebruikerservaring te verbeteren, te personaliseren, analyses voor optimalisatie en advertenties in samenwerking met derde partijen. Wij gebruiken onze eigen cookies en cookies van derde partijen. Door op OK te klikken accepteert u het gebruik van alle cookies. Wij plaatsen altijd noodzakelijke cookies. Selecteer {preferencesUrl}Voorkeuren beheren{/preferencesUrl} om te kiezen welke cookies u wilt accepteren, om uw voorkeur aan te passen en voor meer informatie."
        data-url="https://www.thuisbezorgd.nl/cookieverklaring"
        data-url-text="Voorkeuren beheren."
        data-hide-link-after-text="true"
        data-button-text="OK"
        data-button-text-aria="OK Button"
        data-button-essential-package="Essentiële"
        data-button-essential-package-aria="Essential package aria">
        </div>


    </div>
</template>

<script>

export default {
    mounted() {
        window.addEventListener('load', () => this.addCookies());
    },
    data: function() {
        return {
        }
    },
    methods: {
        addCookies() {
            let cookie;
            let name = "cookieConsent=";
            let decodedCookie = decodeURIComponent(document.cookie);
            let ca = decodedCookie.split(';');

            for(let i = 0; i <ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    cookie = c.substring(name.length, c.length);
                }
            }

            if (cookie == undefined) {

                let cookiesScript = document.createElement('script')
                cookiesScript.setAttribute('src', 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/cookie-styles-09-2022/cookie-wall-with-polyfill.59c6866ee421a693445a.js');
                document.head.appendChild(cookiesScript);

            }
        }
    }
}
</script>